import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import {
    ReferenceArrayInput,
    useRecordContext,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import {
    ADD_TO_SEARCH_PIN_FIELD,
    validateSearchPhraseIds,
} from '@src/validations';

import { StyledSelectArrayInput } from '../Styled';

const SearchPinInput = ({ source }) => {
    const record = useRecordContext();
    const { setValue, clearErrors, trigger } = useFormContext();

    const recordPhraseIdsKey = Array.isArray(record?.[source.searchPhraseIds])
        ? record[source.searchPhraseIds].join(',')
        : '';
    const hasRecordId = record?.id !== undefined && record?.id !== null;
    const syncKey = hasRecordId ? `${record.id}:${recordPhraseIdsKey}` : null;

    const [showPinSection, setShowPinSection] = useState(
        () => hasRecordId && recordPhraseIdsKey.length > 0,
    );
    const [prevSyncKey, setPrevSyncKey] = useState(syncKey);

    if (syncKey !== prevSyncKey && syncKey !== null) {
        setPrevSyncKey(syncKey);
        setShowPinSection(recordPhraseIdsKey.length > 0);
    }

    useEffect(() => {
        setValue(ADD_TO_SEARCH_PIN_FIELD, showPinSection, { shouldDirty: false });
    }, [showPinSection, setValue]);

    const handlePinToggle = (event) => {
        const { checked } = event.target;
        setShowPinSection(checked);
        if (checked) {
            trigger(source.searchPhraseIds);
        } else {
            setValue(source.searchPhraseIds, []);
            clearErrors(source.searchPhraseIds);
        }
    };

    return (
        <>
            <Grid>
                <FormControlLabel
                    control={
                        <Switch
                            checked={showPinSection}
                            onChange={handlePinToggle}
                        />
                    }
                    label="Add to Search Pin"
                />
            </Grid>
            {showPinSection ? (
                <Grid>
                    <ReferenceArrayInput
                        label="Search Phrases"
                        reference={source.searchPhrasesReference}
                        source={source.searchPhraseIds}
                    >
                        <StyledSelectArrayInput
                            optionText="phrase"
                            validate={validateSearchPhraseIds}
                            sx={{ minWidth: 250 }}
                        />
                    </ReferenceArrayInput>
                </Grid>
            ) : null}
        </>
    );
};

SearchPinInput.propTypes = {
    source: PropTypes.shape({
        searchPhraseIds: PropTypes.string.isRequired,
        searchPhrasesReference: PropTypes.string.isRequired,
    }).isRequired,
};

export default React.memo(SearchPinInput);
